import React from 'react'
import PropTypes from 'prop-types'
import { ROUTES } from 'helpers/constants'
import { CloseIcon, InfoIcon, PrimaryButton } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import { OVERLAY } from 'components/AuthModal/styles'
import equalizer from 'assets/images/equalizer.png'

const OrientationWarning = ({ show, onClose, onRouteChange }) => (
  <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
    <Modal innerClassName="overflow-y-scroll flex flex-col justify-center px-5">
      <div className="h-auto bg-tunaGray relative text-white w-full p-5 rounded-xl md:w-96">
        <div className="w-full flex justify-end">
          <button
            className="bg-white bg-opacity-20 w-5 h-5 mb-5 rounded-full flex items-center justify-center"
            onClick={onClose}
          >
            <CloseIcon className="w-2 h-2 text-white" />
          </button>
        </div>
        <img src={equalizer} alt="" className="w-10 mb-6" />
        <div className="text-lg font-bold mb-3">Cannot Update Orientation</div>
        <div className="text-sm opacity-60 mb-5">To update your orientation, go to settings.</div>
        <PrimaryButton
          className="w-full font-bold text-base h-12 mb-12"
          onClick={() => onRouteChange(ROUTES.SETTINGS)}
        >
          Change Orientation in Settings
        </PrimaryButton>
        <div className="flex items-start px-5 py-4 text-sm bg-white bg-opacity-10 rounded-lg">
          <div className="flex justify-center items-center flex-shrink-0 w-4 h-4 bg-regentGray rounded-full mr-3.5">
            <InfoIcon className="w-0.5" />
          </div>
          <div className="text-regentGray">
            If you reserved a ticket to an event, you have to get a refund first, then you can
            change orientation.
          </div>
        </div>
      </div>
    </Modal>
  </Overlay>
)

OrientationWarning.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onRouteChange: PropTypes.func,
}

export default OrientationWarning
